import theme from '../base'

const tooltip = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        display: 'flex',
        padding: theme.spacing(0.25),
        backgroundColor: theme.palette.neutral.dark,
        ...theme.typography.body2,
        boxShadow: theme.shadows[2],
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3),
          margin: theme.spacing(0, 0.25, 0, 0.25),
        },
        '& .MuiTypography-root:not(.MuiLink-root)': {
          flex: 1,
          alignSelf: 'center',
          margin: theme.spacing(0.25, 0.75),
        },
        '& .MuiLink-root': {
          ...theme.typography.body2,
        },
        '&.error': {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
          '& .MuiTooltip-arrow': {
            color: theme.palette.error.light,
          },
        },
        '&.warning': {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.darkest,
          '& .MuiTooltip-arrow': {
            color: theme.palette.warning.light,
          },
        },
        '&.info': {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.darkest,
          '& .MuiTooltip-arrow': {
            color: theme.palette.info.light,
          },
        },
      },
      arrow: {
        color: theme.palette.neutral.dark,
      },
    },
  },
}

export default tooltip
